export default __webpack_public_path__ + "static/media/big-check.c82a6871.svg";